// src/utils/cssParser.js

export const fetchClassNames = async (filename) => {
  const url = `${process.env.REACT_APP_USERMANAGEMENT_URL}?action=downloadCustomCss&filename=${encodeURIComponent(filename)}`
  try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch ${url}: ${response.statusText}`);
      }
      const cssText = await response.text();
      const classNames = new Set();
      const regex = /\.([a-zA-Z0-9_-]+)\s*\{/g;
      let match;
      while ((match = regex.exec(cssText)) !== null) {
        classNames.add(match[1]);
      }
      return Array.from(classNames);
    } catch (error) {
      console.error(`Error fetching or parsing CSS from ${url}:`, error);
      return [];
    }
  };
  